import {gql, useMutation} from "@apollo/client";

const ADD_ORG_MUTATION = gql`
mutation AddTeam($name: String!, $organizationType: String, $profileId: Int, $location: LocationInput, $waiverIds: [ID], $fieldIds: [Int], $sanctionRuleId: ID, $stripeAccountId: ID, $currency: String) {
  createTeam(name: $name, organizationType: $organizationType, profileId: $profileId, location: $location, waiverIds: $waiverIds, fieldIds: $fieldIds, sanctionRuleId: $sanctionRuleId, stripeAccountId: $stripeAccountId, currency: $currency) {
    organization {
        slug
        name
        organizationType {
            code
        }
        divisionsCount
        logoUrl
        id
        address
        currency
        waivers {
            id
            title
        }
        fields{
            id
            name
            description
        }
        sanctionRule{
            id
            name
        }
        stripeAccount{
            id
            name
        }
    }
  }
}
`;

export default function AddOrgMutation() {
    return useMutation(ADD_ORG_MUTATION);
}
